import React from 'react'
import { connect } from 'react-redux'
import { BASE_URL } from 'requests'
import {parseUrlQuery} from 'utilities'
import ls from 'local-storage'
import { Redirect } from 'react-router-dom'

let EpassRedirector = ({match, location, checkingAuthState, loggedIn}) => {
  React.useEffect(() => {
    if(!checkingAuthState && !loggedIn){
      const search = parseUrlQuery(location.search)
      const returnUrl = search.from || '/'
      ls.set('EPASS_RETURN_URL', returnUrl)
      window.location.href = `${BASE_URL}/api/Login.epass`
    }
  }, [checkingAuthState, loggedIn])
  if(!checkingAuthState && loggedIn){
    return <Redirect to="/" />
  }
  return null
}
export default connect(state => ({
  checkingAuthState: state.auth.checkingAuthState,
  loggedIn: state.auth.loggedIn
}))(EpassRedirector)


// WEBPACK FOOTER //
// ./src/components/Epass/EpassRedirector.js